/**
 * company: nextvital gmbh
 * developer: thorsten stefani
 * start: 18.10.2023
 * Version 0.1
*/

const element_vitamind_table = document.querySelector(".nxv-vitamind-table div.btn-show-table");
if(typeof(element_vitamind_table) != 'undefined' && element_vitamind_table != null) {
  document.querySelector(".nxv-vitamind-table div.btn-show-table").addEventListener("click", function(){
    this.classList.toggle('show');
    document.querySelector(".nxv-vitamind-table-wrapper").classList.toggle('show');    
  })
}

/* add to cart animation */
const element_add_to_cart = document.querySelector(".quick-add__submit.nextvital-quick-add-button");
if(typeof(element_add_to_cart) != 'undefined' && element_add_to_cart != null) {
  document.addEventListener('DOMContentLoaded', function() {
      let all_add_to_cart_btn = document.querySelectorAll('.quick-add__submit.nextvital-quick-add-button');
      all_add_to_cart_btn.forEach(function (item) {
        item.addEventListener('click', function(event) {   
          item.classList.add('good-choice-nextvital');
          setTimeout(() => {
              item.classList.remove('good-choice-nextvital');
          }, 2000);    
        });
      });
  });
}


/*
Javascript count down timer
data format: 2021-10-7 18:00:00
*/

function countDownTimer(
    endDate = "2026-08-29 18:00:00",
    targetClass = ".CountdownTimerAnnouncementBar",
    daysLabel = "Tage",
    hoursLabel = "Std",
    minutesLabel = "Min",
    secondsLabel = "Sek"
) {
    function convertDateForIos(date) {

        //console.log('hallo here i am');
        //console.log(targetClass);

    var arr = date.split(/[- :]/);
    date = new Date(
        arr[0],
        arr[1] - 1,
        arr[2],
        arr[3],
        arr[4],
        arr[5]
    ).getTime();
    return date;
    }
    const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
    // get all timer placeholder by class
    const timers = document.querySelectorAll(targetClass);

    let endDay = endDate,
    countDown = convertDateForIos(endDay);
    let x = "";
    let timerHtml = "";
    x = setInterval(
    (function ins1() {
        // lock time zone
        let c = new Date().toLocaleString("en-US", { timeZone: "Europe/Amsterdam" });
        let sensibleFormat = new Date(c);

        let now = sensibleFormat.getTime(),
        distance = countDown - now;
        let dayText = Math.floor(distance / day);
        let hoursText = Math.floor((distance % day) / hour);
        let minutesText = Math.floor((distance % hour) / minute);
        let secondText = Math.floor((distance % minute) / second);
        let label_day = "";
        if( dayText <= 1){
            label_day = "Tag";
        }else{
            label_day = "Tage";
        }
        let label_hour = "";
        if( hoursText <= 1){
            label_hour = "Std";
        }else{
            label_hour = "Std";
        }
        let label_min = "";
        if( minutesText <= 1){
            label_min = "Min";
        }else{
            label_min = "Min";
        }
        let label_sec = "";
        if( secondText <= 9){
            label_sec = "Sek";
        }else{
            label_sec = "Sek";
        }

        if (dayText > 0) {
        timerHtml =  ` 
            <span class="days fs-14 ${dayText}"><strong> ${dayText}</strong>${label_day}</span>
            <span class="hours fs-14 ${hoursText}"><strong> ${hoursText}</strong>${label_hour}</span>
            <span class="minutes fs-14 ${minutesText}"><strong> ${minutesText}</strong>${label_min}</span>
            <span class="secs fs-14 ${secondText.toString().padStart(2, "0")}"><strong> ${secondText.toString().padStart(2, "0")}</strong>${label_sec}</span>`;
        } else if (hoursText > 0) {
        timerHtml = ` 
            <span class="hours fs-14 ${hoursText}"><strong> ${hoursText}</strong>${label_hour}</span>
            <span class="minutes fs-14 ${minutesText}"><strong> ${minutesText}</strong>${label_min}</span>
            <span class="secs fs-14 ${secondText.toString().padStart(2, "0")}"><strong> ${secondText.toString().padStart(2, "0")}</strong>${label_sec}</span>`;
        } else if (minutesText > 0) {
        timerHtml = ` 
            <span class="minutes fs-14 ${minutesText}"><strong> ${minutesText}</strong>${label_min}</span>
            <span class="secs fs-14 ${secondText.toString().padStart(2, "0")}"><strong> ${secondText.toString().padStart(2, "0")}</strong>${label_sec}</span>`;
        } else {
        timerHtml = ` 
            <span class="secs fs-14 ${secondText.toString().padStart(2, "0")}"><strong> ${secondText.toString().padStart(2, "0")}</strong>${label_sec}</span>`;
        }
        timers.forEach(function (element) {
        element.innerHTML = timerHtml;
        });
        //do something later when date is reached
        if (distance < 0) {
            clearInterval(x);
            timers.forEach(function (element) {
                element.remove();
            });
            document.querySelector('.ybl-product-countdown-badge-wrapper.product-counter').style.display = "none";
            document.querySelector('.badge.price__badge-sale.discount-badge').style.display = "inline-block";   
        }
        return ins1;
        //seconds
    })(),
    1000
    );
}
    
/* execute function when element on screen */ 
function onElementReady(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
    return;
  }

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

/* TST - popup utm checker*/ 
// https://nextvital.de?npu
function checkPopupVisibility() {

    
    const urlParams = new URLSearchParams(window.location.search);
    const hidePopup = urlParams.has('npu');

    if (hidePopup) {
        //console.log("Popup wurde per URL-Parameter unterdrückt.");
        
        const elementKlaviyo = document.querySelector(".needsclick.kl-teaser-SLcnZc.kl-private-reset-css-Xuajs1");
        if (typeof elementKlaviyo != "undefined" && elementKlaviyo != null) {
                    document.querySelector('.needsclick.kl-teaser-SLcnZc.kl-private-reset-css-Xuajs1').style.display = "none";
        }

        const style = document.createElement('style');
        style.innerHTML = `
            .needsclick.kl-teaser-SLcnZc, 
            .needsclick.kl-private-reset-css-Xuajs1 { 
                display: none !important; 
                visibility: hidden !important; 
                opacity: 0 !important; 
                pointer-events: none !important;
            }
            body.klaviyo-prevent-body-scrolling{
                overflow: unset !important;
            }    
        `;
        document.head.appendChild(style);

        //console.log("style gesetzt");
        
    }
}

window.onload = checkPopupVisibility;


$(document).ready(function() {

  // add and delete product from customer wishlist in metafield
  $(document).off('click', '.nxt-wishlist-icon').on('click', '.nxt-wishlist-icon', function(e) {

    e.preventDefault();
    e.stopImmediatePropagation();

    const $img = $(this);
    const productId = $img.data('product-id');
    const customerId = $img.data('customer-id');

    const iconEmpty = "icon_heart.svg"; 
    const fullUrl = "https://cdn.shopify.com/s/files/1/0045/8096/6435/files/icon_heart_full_green.svg?v=1785313083";
    const emptyUrl = "https://cdn.shopify.com/s/files/1/0045/8096/6435/files/icn-nextvital-favorit.svg?v=1792059774";
    
    const isFull = $img.attr('src').includes('full');
    $img.attr('src', isFull ? emptyUrl : fullUrl);

    const isDeleting = $img.attr('src').includes('full');

    if(isDeleting){
      refreshWishlistCount('minus'); 
    }else{
      refreshWishlistCount('plus');
    }

    $.ajax({
      type: isDeleting ? "POST" : "DELETE",
      url: "https://py-dev.halbig.io/nv/customer/wishlist",
      data: {
          customer_id: customerId,
          product_id: productId
      },
      success: function(response) {
          if (response.success) {
              //console.log("Erfolgreich aktualisiert");
          } else {
              //console.error("Fehler von API:", response.error);
              // Bei Fehler zurück-togglen
              $img.attr('src', isFull ? fullUrl : emptyUrl);
          }
      },
      error: function() {
          alert("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
          $img.attr('src', isFull ? fullUrl : emptyUrl);
      }
    });
  });

  // set green heart on product teaser
  $(document).off('click', '.nxt-wishlist-btn').on('click', '.nxt-wishlist-btn', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $img = $(this);
    const productId = $img.data('product-id');
    const customerId = $img.data('customer-id');

    const iconEmpty = "icon_heart.svg"; // Wir suchen später nur nach dem Teilstring
    const fullUrl = "https://cdn.shopify.com/s/files/1/0045/8096/6435/files/icon_heart_full_green.svg?v=1785313083";
    const emptyUrl = "https://cdn.shopify.com/s/files/1/0045/8096/6435/files/icn-nextvital-favorit.svg?v=1792059774";
    
    const isFull = $img.attr('src').includes('full');
    $img.attr('src', isFull ? emptyUrl : fullUrl);

    const isDeleting = $img.attr('src').includes('full');
  });
});

const Wishlist = {
  STORAGE_KEY: 'nextvital_wishlist',

  // get wishlist from session storage
  getWishlist() {
    const saved = sessionStorage.getItem(this.STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  },

  // add product to session storage 
  toggleProduct(productId, element) {
    let list = this.getWishlist();
    const index = list.indexOf(productId);

    if (index === -1) {
      list.push(productId);
    } else {
      list.splice(index, 1);
    }

    if (element) {   
      if (element.classList.contains('is-active')) {
        element.classList.remove('is-active');
      } else {
        element.classList.add('is-active');  
      }
    }

    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(list));
    refreshWishlistCount();
    this.updateUI();

  },

  updateUI() {
    const count = this.getWishlist().length;
    const badge = document.querySelector('.wishlist-count');
    if (badge) badge.textContent = count;
    
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count } }));
  }
};

// delete session storage, when user logged out
document.addEventListener('DOMContentLoaded', function() {
  const logoutLinks = document.querySelectorAll('a[href^="/account/logout"]');
  logoutLinks.forEach(link => {
    link.addEventListener('click', function() {
      sessionStorage.removeItem('nextvital_wishlist');   
    });
  });
});
